import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { UsernamePassword } from '@imprivata/nucleus';
import headerImage from '../../images/lock.svg';
import * as actions from '../../actions';
import { GetMessageProtocols } from '../../constants/clientProtocols';
import { UNMET_AUTHENTICATION_REQUIREMENTS } from '../../constants/errorCodes';

/**
 * UsernamePasswordPage Component
 */
export class UsernamePasswordPage extends Component {
  /**
   * The allowed properties for the UsernamePasswordPage component
   * @param {function} startAuthSession The function that begins the authentication session
   * @param {array} errorCode The original error code
   * @param {array} errorMessage The array of error messages to display
   * @param {bool} isLoading Whether or not something is loading
   * @param {bool} secondFactorError Whether or not there is an error with the second factor authentication credentials
   */
  static propTypes = {
    startAuthSession: PropTypes.func.isRequired,
    errorCode: PropTypes.string,
    errorMessage: PropTypes.array,
    isLoading: PropTypes.bool,
    secondFactorError: PropTypes.bool,
    initialUsername: PropTypes.string,
    initialPassword: PropTypes.string,
    isEpcsWorkflow: PropTypes.bool,
    isEpcsError: PropTypes.bool,
    errorHandlerUrl: PropTypes.string,
    /** Use Parkland custom UX */
    useCustomUX: PropTypes.bool,
  };

  getHeaderTitle = () => {
    if (this.props.isEpcsWorkflow) {
      return 'Sign order';
    }
    else {
      return 'Log in';
    }
  };

  getSubmitButtonText = () => {
    if (this.props.isEpcsError) {
      return 'Close';
    }
    else if (this.props.isEpcsWorkflow) {
      return 'Continue';
    }
    else {
      return 'Log in';
    }
  };

  submitForm = data => {
    if (this.props.isEpcsError) {
      window.location.href = this.props.errorHandlerUrl + '?error_code=' + UNMET_AUTHENTICATION_REQUIREMENTS;
    }
    else {
      this.props.startAuthSession(data.username, data.password);
    }
  };

  componentDidMount() {
    if (this.props.initialUsername && this.props.initialPassword) {
      setTimeout( () => this.props.startAuthSession(this.props.initialUsername, this.props.initialPassword), 100);
    }
  }

  render() {
    return (
      <div className='content-body'>
        <UsernamePassword
          headerTitle={this.getHeaderTitle()}
          isLoading={this.props.isLoading}
          headerImage={headerImage}
          onSubmit={this.submitForm}
          displayErrors={this.props.errorMessage}
          autoFocus={!this.props.initialUsername}
          autoFocusPassword={!!this.props.initialUsername}
          logoutComponent={null}
          disableUsernameInput={this.props.isEpcsWorkflow && this.props.isEpcsError && this.props.errorHandlerUrl}
          disablePasswordInput={this.props.isEpcsWorkflow && this.props.isEpcsError && this.props.errorHandlerUrl}
          enableSubmit={this.props.isEpcsWorkflow && this.props.isEpcsError && this.props.errorHandlerUrl}
          submitText={this.getSubmitButtonText()}
          highlightFields={this.props.secondFactorError}
          initialUsername={this.props.initialUsername}
          initialPassword={this.props.initialPassword}
          /** Use Parkland custom UX */
          useCustomUX={this.props.useCustomUX}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    isLoading, errorCode, errorMessage, secondFactorError, initialUsername, initialPassword, isEpcsWorkflow,
    errorHandlerUrl, useCustomUX,
  } = state.login;
  const { GetMsgWorkflowNotEnabled, GetMsgWorkflowNotAllowed, } = GetMessageProtocols;
  const isEpcsError =
    errorCode === GetMsgWorkflowNotEnabled.asString || errorCode === GetMsgWorkflowNotAllowed.asString;
  return {
    isLoading,
    errorCode,
    errorMessage,
    secondFactorError,
    initialUsername,
    initialPassword,
    isEpcsWorkflow,
    isEpcsError,
    errorHandlerUrl,
    useCustomUX,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    startAuthSession: (username, credential) => {
      dispatch(actions.startAuthSession(username, credential) );
    },
  };
};

/* istanbul ignore next */


export default connect(mapStateToProps, mapDispatchToProps)(UsernamePasswordPage);
